<!--
 * @Author: zhangzibo
 * @Date: 2021-07-24 16:39:39
 * @Description: 视频专辑
-->
<template>
  <div class="album">
    <tip></tip>
    <template v-if="videoObj.enable">
      <empty></empty>
    </template>
    <template v-else>
      <div class="conntent">
        <div class="big-img">
          <img :src="videoObj.pic" alt="">
          <span class="zhuanjie" style="display: none;">文本</span>
        </div>
      </div>
      <div class="videoList-box" v-if="videoObj && videoObj.name">
        <div class="text-content">
          <div class="title" @click="topage">
          <span class="hs-title">
            {{ videoObj.name.slice(0,15) }}
          </span>
            <span class="zhuanji">文本</span>
          </div>
          <div class="header-img">
            <img :src="videoObj.uavatar" alt="">
            <div class="header-title" v-if="videoObj.uname">{{ videoObj.uname.slice(0,15) }}</div>
            <div class="palyall" v-if="videoObj.audio_link" @click="topage(videoObj.audio_link)">
              <div  >
                <img src="../../assets/img/audio.png" alt="">
                <span>音频</span>
              </div>
            </div>
            <div class="palyall2" v-if="videoObj.video_link" @click="topage(videoObj.video_link)">
              <div >
                <img src="../../assets/img/btnbofang.png" alt="">
                <span>视频</span>
              </div>
            </div>
          </div>
          <div class="synopsis">
            <p class="synopsis-text" :class="{ zhankai: !iszhankai }">简介：{{videoObj.description}}</p>
            <span @click="zhankaiFn" v-if="videoObj.description && videoObj.description.length > 48">
            <img v-if="!iszhankai" src="../../assets/img/zhankan.png" alt="">
            <img v-if="iszhankai" src="../../assets/img/shouqi.png" alt="">
          </span>
          </div>
        </div>
        <div style="height: 100vh; position: relative; background-color: #fff;" id="pdf">
          <div class="pdftool-container">
            <div class="pagination">
              <input class="current-page" value="1"
                     :id="idConfig.pageNumber"
                     type="number"
                     name="pageNumber"
                     style="width: 40px;border-radius: 10px;"
              >

              <span class="total-pages">/ {{pdfTotal}}</span>
            </div>
            <div class="buttons" style="display: flex; justify-content: flex-end;">
              <button class="up-button" :id="idConfig.firstPage" @click="toTop">

              </button>
              <button class="down-button"  :id="idConfig.lastPage" @click="toAttom">

              </button>
<!--              <button class="grid-button" :id="idConfig.sidebarToggle" @click="toggleThumbnails">-->
<!--              </button>-->
            </div>
          </div>
          <!-- 添加全屏遮罩层，根据工具栏吸顶状态显示/隐藏 -->
          <div
              v-if="!isToolbarSticky"
              class="pdf-fullscreen-overlay"
              @click="scrollToToolbar"
          ></div>
          <vue-pdf-app :pdf="videoObj.url" theme="light" :config="pdfConfig"
                       :id-config="idConfig" @open="openHandler" @pages-rendered="pagesRendered"
                       class="full-width-pdf"></vue-pdf-app>
        </div>
        <!--      <div class="videoList" style="" v-else>-->
        <!--        <div class="container" @click="showDialog = true;">-->
        <!--          <div class="circle">-->
        <!--            <img src="../../assets/img/doc-lock.png" alt="示例图片" class="image" />-->
        <!--          </div>-->
        <!--          <p class="text">点击解锁内容</p>-->
        <!--        </div>-->
        <!--      </div>-->
      </div>
      <Dialog
          :visible="showDialog"
          title="输入密码，解锁内容"
          @close="showDialog = false"
          @cancel="showDialog = false"
          @confirm="handleConfirm"
      />
    </template>

  </div>
</template>

<script>
import tip from '@/components/tip.vue';
import empty from '@/components/empty.vue'
import {Indicator, Toast} from 'mint-ui';
import wechat from "@/plugins/wx";
import Dialog from "@/components/dialog.vue";
import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
import "vue-pdf-app/dist/icons/main.css";
const getSidebar = () => ({
  viewThumbnail: true,
  viewOutline: true,
  viewAttachments: true,
});
// const getSecondaryToolbar = () => ({
//   secondaryPresentationMode: false,
//   secondaryOpenFile: false,
//   secondaryPrint: false,
//   secondaryDownload: false,
//   secondaryViewBookmark: false,
//   firstPage: false,
//   lastPage: false,
//   pageRotateCw: false,
//   pageRotateCcw: false,
//   cursorSelectTool: false,
//   cursorHandTool: false,
//   scrollVertical: false,
//   scrollHorizontal: false,
//   scrollWrapped: false,
//   spreadNone: false,
//   spreadOdd: false,
//   spreadEven: false,
//   documentProperties: false,
// });
// const getToolbarViewerLeft = () => ({
//   findbar: false,
//   previous: true,
//   next: true,
//   pageNumber: true,
// });
// const getToolbarViewerRight = () => ({
//   presentationMode: false,
//   openFile: false,
//   print: false,
//   download: false,
//   viewBookmark: false,
// });
// const getToolbarViewerMiddle = () => ({
//   zoomOut: false,
//   zoomIn: false,
//   scaleSelectContainer: false,
// });
// const getToolbar = () => ({
//   toolbarViewerLeft: getToolbarViewerLeft(),
//   toolbarViewerRight: getToolbarViewerRight(),
//   toolbarViewerMiddle: getToolbarViewerMiddle(),
function getDistance(touch1, touch2) {
  const dx = touch2.clientX - touch1.clientX;
  const dy = touch2.clientY - touch1.clientY;
  return Math.sqrt(dx * dx + dy * dy);
}

// });
export default {
  components: {
    Dialog,
    tip,
    VuePdfApp,
    empty,
  },
  data() {
    return {
      videoObj: {},
      videoList: [],
      id: 0,
      iszhankai: false,
      shareConfig: {
        title: '分享标题',
        desc: '这是一个测试的微信分享',
        link: '', // 分享链接
        imgUrl: '', // 分享图标
      },
      showDialog:false,
      selectItem:{},//当前选中的
      pdfConfig: {
        sidebar: getSidebar(),
        secondaryToolbar: false, // 禁用二级工具栏
        toolbar: false, // 禁用主工具栏
        toolbarSidebar: false, // 禁用侧边栏工具栏
        //sidebarToggle: false, // 禁用侧边栏切换按钮
        errorWrapper: true,
        sidebarVisible: false, // 控制侧栏是否可见
      },
      idConfig: {
        // previousPage: "vuePdfAppPreviousPage",
        // nextPage: "vuePdfAppNextPage",
        firstPage: "vuePdfAppFirstPage",
        lastPage: "vuePdfAppLastPage",
        numPages: "vuePdfAppNumPages",
        pageNumber: "vuePdfAppPageNumber",
        //sidebarToggle: "vuePdfAppSidebarToggle",
      },
      canView:true,
      info:[],
      pdfTotal:0,
      pdfContainer: null,
      isAtBottom: false,
      isToolbarSticky: false, // 新增：记录工具栏是否吸顶
      scrollHandler: null, // 滚动事件处理器引用
      intervalCheck: null, // 定时器引用
      pdfInstance: null, // 保存PDF实例引用
    }
  },
  mounted(){
    // let id = this.$route.query.id ? this.$route.query.id : "";
    // if(id!==""){
    //   let key = "book-auth-"+id
    //
    // }
    // const tipHeight = document.querySelector('.tip-top').offsetHeight;
    // document.querySelector('.pdftool-container').style.top = `${tipHeight}px`;
    
    // 移除可能已存在的滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
    
    // 定义一个具名函数，确保能正确移除
    this.scrollHandler = () => {
      console.log("滚动事件触发",this.isToolbarSticky);
      this.handleScroll();
    };
    
    // 添加滚动事件监听 - 使用具名函数和捕获阶段
    window.addEventListener('scroll', this.scrollHandler, { capture: true });
    
    // 添加触摸滚动事件支持
    window.addEventListener('touchmove', this.scrollHandler, { capture: true });
    
    // 确保初始加载时也执行一次滚动处理
    // this.$nextTick(() => {
    //   console.log("mounted执行handleScroll");
    //   this.handleScroll();
    // });
    
    // 获取PDF容器元素
    this.pdfContainer = document.getElementById('pdf');
    if (this.pdfContainer) {
      // 先禁用PDF的滚动
      this.disablePdfScroll();
    }
    
    // 每秒检查一次状态（备用方案，确保状态更新）
    // this.intervalCheck = setInterval(() => {
    //   this.handleScroll();
    // }, 1000);
  },
  beforeDestroy() {
    // 组件销毁前移除滚动事件监听
    window.removeEventListener('scroll', this.scrollHandler, { capture: true });
    window.removeEventListener('touchmove', this.scrollHandler, { capture: true });
    
    // 清除定时器
    if (this.intervalCheck) {
      clearInterval(this.intervalCheck);
    }
    
    // 断开MutationObserver连接
    if (this._textLayerObserver) {
      this._textLayerObserver.disconnect();
      this._textLayerObserver = null;
    }
    
    // 断开布局观察器连接
    if (this._layoutObserver) {
      this._layoutObserver.disconnect();
      this._layoutObserver = null;
    }
    
    // 移除复制事件监听器
    if (this.pdfContainer) {
      this.pdfContainer.removeEventListener('copy', this.preventCopy);
    }
  },
  created () {
    this.id = this.$route.query.id || 1
    this.getVideoList()
    this.report(this.id,8)
  },
  methods: {
    toTop(){
      Toast({
        message:'文档已跳转至首页',
        duration: 1000,
        className: 'custom-toast'
      });
    },
    toAttom(){
      Toast({
        message:'文档已跳转至尾页',
        duration: 1000,
        className: 'custom-toast'
      });
    },
    // 滚动事件处理函数
    handleScroll() {
    
      // 检查是否滚动到了PDF容器底部
      if (!this.pdfContainer) {
      
        return;
      }
      
      // 检查pdftool-container是否已经吸顶到tip组件位置
      const pdfToolContainer = document.querySelector('.pdftool-container');
      const tipComponent = document.querySelector('.tip-top');
      
      let isToolbarSticky = false;
      console.log("257行");
      if (pdfToolContainer && tipComponent) {
        // 获取tip组件底部位置
        const tipBottom = tipComponent.getBoundingClientRect().bottom;
        // 获取工具栏顶部位置
        const toolbarTop = pdfToolContainer.getBoundingClientRect().top;
        
        // 当工具栏顶部位置 <= tip组件底部位置时，认为工具栏已吸顶
        isToolbarSticky = toolbarTop <= tipBottom;
        
      }
      
      
      // 更新工具栏吸顶状态
      const prevState = this.isToolbarSticky;
      this.isToolbarSticky = isToolbarSticky;
      
      
      // 根据工具栏吸顶状态控制PDF滚动
      if (isToolbarSticky) {
        // 工具栏已吸顶，启用PDF内部滚动
        this.enablePdfScroll();
      } else {
        // 工具栏未吸顶，禁用PDF内部滚动
        this.disablePdfScroll();
      }
      
      // 如果状态发生变化，记录日志
      if (prevState !== isToolbarSticky) {
        console.log("工具栏吸顶状态变化:", isToolbarSticky ? "已吸顶" : "未吸顶");
      }
    },
    // 禁用PDF内部滚动
    disablePdfScroll() {
      if (this.pdfContainer) {
        // 找到PDF查看器元素
        const pdfViewer = this.pdfContainer.querySelector('.pdfViewer');
        if (pdfViewer) {
          // 先移除可能已存在的事件监听
          pdfViewer.removeEventListener('wheel', this.preventScroll);
          pdfViewer.removeEventListener('touchmove', this.preventScroll);
          
          // 添加滚轮事件监听
          pdfViewer.addEventListener('wheel', this.preventScroll, { passive: false });
          pdfViewer.addEventListener('touchmove', this.preventScroll, { passive: false });
        }
      }
    },
    // 启用PDF内部滚动
    enablePdfScroll() {
      if (this.pdfContainer) {
        const pdfViewer = this.pdfContainer.querySelector('.pdfViewer');
        if (pdfViewer) {
          // 移除滚轮事件的监听器，允许滚动
          pdfViewer.removeEventListener('wheel', this.preventScroll);
          pdfViewer.removeEventListener('touchmove', this.preventScroll);
        }
      }
    },
    // 阻止滚动事件的处理函数
    preventScroll(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    },
    handleOverlayClick() {
      // 点击覆盖层时，执行平滑滚动到PDF区域的底部
      const scrollHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;
      
      // 计算滚动位置，使PDF区域位于视口中心
      const targetPosition = scrollHeight - windowHeight;
      
      // 使用平滑滚动效果
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
      
      // 滚动后激活PDF滚动
      setTimeout(() => {
        this.isAtBottom = true;
        this.enablePdfScroll();
      }, 500); // 等待滚动完成
    },
    async openHandler(pdfApp) {
      // 保存PDF实例引用
      this.pdfInstance = pdfApp;
      
      // 初次加载后，如果需要显示缩略图，调整其位置
      if (this.pdfConfig.sidebarVisible) {
        this.$nextTick(() => {
          this.adjustSidebarPosition();
        });
      }
    },
    pagesRendered(pdfApp) {
      console.log('pdf信息',pdfApp);
      this.pdfTotal = pdfApp.pagesCount;
      this.pdfInstance = pdfApp;
      
      setTimeout(() => {
        // 设置页面宽度适应视口
        pdfApp.pdfViewer.currentScaleValue = "page-width";
        
        // PDF渲染完成后的处理
        this.$nextTick(() => {
          this.pdfContainer = document.getElementById('pdf');
          if (this.pdfContainer) {
            this.disablePdfScroll();
            this.handleScroll();
            this.disableTextSelection(pdfApp);
            
            // 额外的样式调整，使PDF更好地融入页面
            this.adjustPdfLayout(pdfApp);
            
            // 添加双击缩放功能
            //this.addDoubleClickZoom(pdfApp);
            
            // 确保初始状态下侧边栏是关闭的
            if (pdfApp.pdfSidebar && !this.pdfConfig.sidebarVisible) {
              pdfApp.pdfSidebar.close();
            }
            
            // 隐藏工具栏侧边栏相关元素
            //this.hideToolbarElements();
          }
        });
      });
    },
    // 隐藏PDF查看器中的工具栏和侧边栏相关元素
    // hideToolbarElements() {
    //   // 隐藏工具栏侧边栏
    //   const toolbarSidebar = document.querySelector('.toolbarSidebar');
    //   if (toolbarSidebar) {
    //     toolbarSidebar.style.display = 'none';
    //   }
      
    //   // 隐藏侧边栏容器内的工具栏
    //   const sidebarToolbar = document.querySelector('#sidebarContainer .toolbar');
    //   if (sidebarToolbar) {
    //     sidebarToolbar.style.display = 'none';
    //   }
      
    //   // 隐藏侧边栏内的页签工具栏
    //   const tabsToolbar = document.querySelector('#sidebarContainer .tabsToolbar');
    //   if (tabsToolbar) {
    //     tabsToolbar.style.display = 'none';
    //   }
      
    //   // 隐藏其他可能的工具栏相关元素
    //   const toolbarElements = document.querySelectorAll('.toolbar, .toolbarButton, .toolbarField');
    //   toolbarElements.forEach(element => {
    //     if (element.id !== idConfig.sidebarToggle && 
    //         element.id !== idConfig.firstPage && 
    //         element.id !== idConfig.lastPage && 
    //         element.id !== idConfig.pageNumber) {
    //       element.style.display = 'none';
    //     }
    //   });
    // },
    handleConfirm(value) {
      if(value==this.videoObj.view_pass){
        localStorage.setItem(`book-auth-${this.id}`, value);
        this.showDialog = false
        this.canView = true;
      }else{
        Toast({
          message:'密码不对！',
        });
      }

    },
    checkAccess(item) {
      let view_pass = item?.view_pass;
      if(view_pass==undefined){
        console.log("22222222222",view_pass,item)
        return true
      }
      // 检查 item 是否存在 view_pass 且非空
      if (view_pass.trim() !== '') {
        // 从 sessionStorage 读取指定 key 的值（假设 key 为 'view_pass_key'）
        const storedValue = sessionStorage.getItem(`view_pass_key_${item.id}`);

        // 检查存储的值是否存在且与 item.view_pass 一致
        if (storedValue !== null && storedValue === item.view_pass) {
          console.log("333333333",view_pass)
          return true; // 满足条件返回 true
        }else{
          return false;
        }
      }
      console.log("4444444444",view_pass)
      return true; // 其他情况返回 false
    },
    async report(id,dt) {
      try {
        // 发送点击事件请求到服务端
        await this.$report.sendReport({
          "id": id,
          "dt":dt
        });

      } catch (error) {
        console.error("Error sending click request:", error);
      }
    },
    topage(url){
      this.$router.push(url)
    },
    topageDetail(i){
      console.log("点击嘻嘻嘻",i);
      if(this.checkAccess(i)){
        this.$router.push(`/videoDetail?id=${i.id}`)
      }else{
        this.showDialog = true;
        this.selectItem = i;
      }

    },
    toBuy(link){
      window.open(link, '_blank');
    },
    zhankaiFn(){
      this.iszhankai = !this.iszhankai
    },
    async getVideoList() {
      try {
        Indicator.open()
        this.id = this.$route.query.id || 1
        //const res = await this.axios.get(`https://new-videoapi.ayerdudu.com/val_${this.id}.html`)
        //const res = await this.axios.get(`https://api.ayerdudu.com/v1/video/album/data/${this.id}`)
        const res = await this.axios.get(`https://api.ayerdudu.com/v1/book/${this.id}`)
        this.videoObj = res.data.data;
        const currentUrl = window.location.href.split('#')[0];
        this.shareConfig.title = this.videoObj.name;
        this.shareConfig.desc = this.videoObj.description;
        this.shareConfig.link = currentUrl;
        this.shareConfig.imgUrl = this.videoObj.pic;
        console.log('分享配置',this.shareConfig);
        //const currentUrl = 'http://videos.ayerdudu.com/audioDetail?id=d1b469a1-91f4-1400-d29e-241571036c3c';
        wechat.initConfig(currentUrl).then(() => {
          // 配置分享内容
          wechat.setShareOptions(this.shareConfig);
        });
        this.videoList = res.data.data.video_list;
        this.canView = this.$checkViewPass("book-auth-"+this.id,this.videoObj.view_pass);
        Indicator.close()
      } catch (err) {
        Indicator.close()
        console.log(err)
      }
    },
    // 禁止PDF文本选择和复制的方法
    disableTextSelection(pdfApp) {
      // 1. 通过CSS禁止选择
      const pdfViewer = this.pdfContainer.querySelector('.pdfViewer');
      if (pdfViewer) {
        pdfViewer.classList.add('no-text-select');
      }
      
      // 2. 通过事件拦截禁止复制
      // 存储preventCopy引用便于后续移除事件监听
      this.preventCopy = (e) => {
        e.preventDefault();
        return false;
      };
      
      // 阻止复制事件
      this.pdfContainer.addEventListener('copy', this.preventCopy);
      
      // 3. 禁用文本层选择功能 (通过覆盖PDFJS中的方法)
      if (pdfApp && pdfApp.pdfViewer) {
        // 添加自定义样式到每个文本层
        const applyToTextLayers = () => {
          const textLayers = this.pdfContainer.querySelectorAll('.textLayer');
          textLayers.forEach(layer => {
            layer.classList.add('no-text-select');
            layer.style.pointerEvents = 'none'; // 禁止鼠标交互
          });
        };
        
        // 立即应用一次
        applyToTextLayers();
        
        // 当页面渲染或更新时再次应用
        const observer = new MutationObserver(applyToTextLayers);
        observer.observe(this.pdfContainer, { 
          childList: true, 
          subtree: true 
        });
        
        // 保存observer引用以便在组件销毁时断开连接
        this._textLayerObserver = observer;
      }
    },
    // 调整PDF布局以融入页面
    adjustPdfLayout() {
      if (!this.pdfContainer) return;
      
      // 获取PDF查看器容器
      const viewerContainer = this.pdfContainer.querySelector('#viewerContainer');
      const pdfViewer = this.pdfContainer.querySelector('.pdfViewer');
      
      if (viewerContainer && pdfViewer) {
        // 移除边距和多余空间
        viewerContainer.style.top = '0';
        viewerContainer.style.bottom = '0';
        viewerContainer.style.left = '0';
        viewerContainer.style.right = '0';
        
        // 调整页面间距和对齐
        pdfViewer.style.padding = '0';
        pdfViewer.style.paddingBottom='92px';
        pdfViewer.style.textAlign = 'center';
        
        // 移除页面阴影和边框
        const pages = pdfViewer.querySelectorAll('.page');
        pages.forEach(page => {
          page.style.boxShadow = 'none';
          page.style.border = 'none';
          page.style.borderBottom = '3px solid gray';
          // page.style.border = 'none';
          // page.style.margin = '0';
          // page.style.backgroundColor ='red';
          // page.style.width = '100%';
          // page.style.display = 'flex';
          // page.style.justifyContent ='center';
        });

        // 监听页面变化，自动应用样式
        const layoutObserver = new MutationObserver(() => {
          const newPages = pdfViewer.querySelectorAll('.page:not(.adjusted)');
          newPages.forEach(page => {
            page.style.boxShadow = 'none';
            page.style.border = 'none';
            page.style.borderBottom = '3px solid gray';
            // page.style.border = 'none';
            // page.style.margin = '0';
            // page.style.backgroundColor ='red';
            // page.style.width = '100%';
            // page.style.display = 'flex';
            // page.style.justifyContent ='center';
            page.classList.add('adjusted');
          });
        });
        
        layoutObserver.observe(pdfViewer, { 
          childList: true, 
          subtree: true 
        });
        
        // 保存observer引用以便在组件销毁时断开连接
        this._layoutObserver = layoutObserver;
      }
    },
    // 添加双击缩放功能
    addDoubleClickZoom(pdfApp) {
      if (!pdfApp || !pdfApp.pdfViewer) return;
      
      // 存储当前缩放状态
      let isZoomed = false;
      let originalScale = pdfApp.pdfViewer.currentScaleValue;
      
      // 获取PDF查看器容器
      const viewerContainer = this.pdfContainer.querySelector('#viewerContainer');
      if (!viewerContainer) return;
      
      // 添加双击事件
      viewerContainer.addEventListener('dblclick', (event) => {
        // 阻止默认行为和冒泡
        event.preventDefault();
        event.stopPropagation();
        
        if (!isZoomed) {
          // 放大到固定值
          originalScale = pdfApp.pdfViewer.currentScaleValue;
          pdfApp.pdfViewer.currentScaleValue = 1.5; // 可以调整这个值，根据需要放大的程度
          isZoomed = true;
        } else {
          // 恢复原始大小
          pdfApp.pdfViewer.currentScaleValue = originalScale;
          isZoomed = false;
        }
      });
      let initialDistance = 0;
      let initialScale = 1;

      viewerContainer.addEventListener('touchstart', (event) => {
        if (event.touches.length === 2) {
          event.preventDefault();

          // 记录初始两指间的距离
          initialDistance = getDistance(event.touches[0], event.touches[1]);
          initialScale = pdfApp.pdfViewer.currentScaleValue;
        }
      });

      viewerContainer.addEventListener('touchmove', (event) => {
        if (event.touches.length === 2) {
          event.preventDefault();

          const newDistance = getDistance(event.touches[0], event.touches[1]);
          const scaleChange = newDistance / initialDistance;

          // 设置新的缩放比例
          pdfApp.pdfViewer.currentScaleValue = Math.min(
              Math.max(initialScale * scaleChange, 0.5), // 最小 0.5
              3                                         // 最大 3
          );
        }
      });


    },
    // 点击遮罩层，滚动到工具栏位置使其吸顶
    scrollToToolbar() {
      const pdfToolContainer = document.querySelector('.pdftool-container');
      const tipComponent = document.querySelector('.tip-top');
      const extraScroll = 92;
      if (pdfToolContainer && tipComponent) {
        // 计算tip组件底部的位置
        const tipBottom = tipComponent.getBoundingClientRect().bottom;

        // 计算工具栏的当前位置
        const toolbarRect = pdfToolContainer.getBoundingClientRect();

        // 计算需要滚动的距离，使工具栏顶部与tip组件底部对齐
        const scrollDistance = window.pageYOffset + toolbarRect.top - tipBottom+extraScroll;
        // 滚动到适当位置，确保工具栏与tip组件底部对齐
        window.scrollTo({
          top: scrollDistance,
          behavior: 'smooth'
        });
      }
    },
    // 切换缩略图显示
    toggleThumbnails() {
      // 切换侧边栏显示状态
      this.pdfConfig.sidebarVisible = !this.pdfConfig.sidebarVisible;
      
      // 如果有PDF实例，直接调用其方法
      if (this.pdfInstance && this.pdfInstance.pdfSidebar) {
        if (this.pdfConfig.sidebarVisible) {
          // 打开侧边栏并显示缩略图视图
          this.pdfInstance.pdfSidebar.open();
          this.pdfInstance.pdfSidebar.switchView(0); // 0 表示缩略图视图
          
          // 侧边栏打开后调整样式
          this.$nextTick(() => {
            this.adjustSidebarPosition();
          });
        } else {
          // 关闭侧边栏
          this.pdfInstance.pdfSidebar.close();
          
          // 强制隐藏侧边栏
          this.$nextTick(() => {
            const sidebarContainer = document.querySelector('#sidebarContainer');
            if (sidebarContainer) {
              sidebarContainer.style.display = 'none';
            }
            
            const outerContainer = document.querySelector('#outerContainer');
            if (outerContainer) {
              outerContainer.classList.remove('sidebarOpen', 'sidebarResizing');
            }
          });
        }
      }
    },
    // 调整侧边栏位置到右侧
    adjustSidebarPosition() {
      const sidebarElement = document.querySelector('#sidebarContainer');
      const viewerContainer = document.querySelector('#viewerContainer');
      const mainContainer = document.querySelector('#mainContainer');

      if (sidebarElement && viewerContainer && mainContainer) {
        // 确保侧边栏可见
        sidebarElement.style.display = 'block';
        
        // 移动侧边栏到右侧
        mainContainer.style.flexDirection = 'row-reverse';

        // 调整宽度和样式
        sidebarElement.style.width = '200px';
        sidebarElement.style.minWidth = '200px';

        // 隐藏侧边栏工具栏
        const sidebarToolbar = sidebarElement.querySelector('#toolbarSidebar');
        if (sidebarToolbar) {
          sidebarToolbar.style.display = 'none';
        }
        
        // 隐藏标签工具栏
        const tabsToolbar = sidebarElement.querySelector('.tabsToolbar');
        if (tabsToolbar) {
          tabsToolbar.style.display = 'none';
        }
        
        // 调整缩略图容器的位置，使其填满整个侧边栏
        const thumbnailView = sidebarElement.querySelector('#thumbnailView');
        if (thumbnailView) {
          thumbnailView.style.top = '0';
          thumbnailView.style.paddingTop = '0';
        }
        
        // 为缩略图页码添加样式
        const thumbnails = sidebarElement.querySelectorAll('.thumbnail');
        thumbnails.forEach((thumbnail, index) => {
          // 移除可能已存在的页码标签
          const existingLabel = thumbnail.querySelector('.thumbnail-page-number');
          if (existingLabel) {
            existingLabel.remove();
          }
          
          // 创建新的页码标签容器，放在缩略图下方
          const pageNumberContainer = document.createElement('div');
          pageNumberContainer.className = 'thumbnail-page-number';
          pageNumberContainer.textContent = index + 1;
          
          // 将页码标签添加到缩略图元素中
          thumbnail.appendChild(pageNumberContainer);
          
          // 调整缩略图和页码的布局样式
          thumbnail.style.display = 'flex';
          thumbnail.style.flexDirection = 'column';
          thumbnail.style.alignItems = 'center';
          thumbnail.style.marginBottom = '25px'; // 为页码腾出空间
        });
      }
    },
  }
}
</script>
<style>
.page {
  width: 100% !important;
  margin: 0 !important;       /* 去掉外边距 */
  padding: 0;

  display: flex;              /* 用 flex 控制子元素居中 */
  justify-content: center;    /* 水平居中 */
}
.page .canvasWrapper,
.page .textLayer {
  width: 350px;               /* 子元素固定宽度 */
  margin: 0 auto;             /* 保险起见 */
}
.custom-toast{
  width: 292px !important; /* 宽度 */
  height: 64px !important; /* 高度 */
  border-radius: 5px !important; /* 圆角 */
  background-color: #393939 !important; /* 背景色 */
  font-size: 24px !important; /* 字体大小 */
  color: #ffffff !important; /* 字体颜色 */
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.custom-toast span{
  font-size: 24px !important;
}
</style>
<style lang="less" scoped>

.album{
  width: 100%;
  min-height: 100%;
  //overflow: hidden;
  //overflow-y: scroll;
  background: #f6f6f6;
  &::-webkit-scrollbar {
    display: none;
  }
  .conntent{
    height: 100%;
    background: #fff;
    padding-bottom: 28px;
    padding-top: 28px;
    .big-img{
      width: 363px;
      height: 363px;
      margin: 0 auto 28px;
      position: relative;
      overflow: hidden;
      border-radius: 20px;
      // border: 1px solid #eee;
      box-shadow:0px 1px 4px rgba(0,0,0,0.3),0 0 40px rgba(0,0,0,0.1) inset;
      // webkit-box-shadow:0px 1px 4px rgba(0,0,0,0.3),0 0 40px rgba(0,0,0,0.1) inset;
      // moz-box-shadow:0px 1px 4px rgba(0,0,0,0.3),0 0 40px rgba(0,0,0,0.1) inset;
      // o-box-shadow:0px 1px 4px rgba(0,0,0,0.3),0 0 40px rgba(0,0,0,0.1) inset;
      img{
        width: 100%;
        height: 100%;
      }
      .zhuanjie{
        position: absolute;
        top: -57px;
        right: -53px;
        background: #22b07d;
        color: #fff;
        width: 120px;
        height: 120px;
        border-radius: 50%;
        line-height: 174px;
        font-size: 24px;
        text-indent: 10px;
      }
    }
    .title{
      line-height: 54px;
      font-size: 36px;
      text-align: center;
      padding: 0 40px;
      font-weight: bold;
    }
    .author_info{
      height: 46px;
      overflow: hidden;
      position: relative;
      margin: 25px 0 20px 0;
      .span_info{
        display: inline-block;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      .span-img{
        float: left;
        width: 46px;
        height: 46px;
        img{
          width: 100%;
          height: 100%;
          border-radius: 50%;
          box-shadow: 1px solid #bfbfbf;
        }
        margin-right: 12px;
      }
      .auther{
        float: left;
        height: 46px;
        font-size: 26px;
        line-height: 55px;
      }
    }
  }
  .item-box{
    margin-top: 28px;
    height: 270px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    overflow-x: scroll;
    margin-bottom: 38px;
    &::-webkit-scrollbar {
      display: none;
    }
    .width20{
      display: inline-block;
      height: 268px;
      width: 40px;
      vertical-align: top; // 此处新增
    }
    .item-list{
      display: inline-block;
      height: 268px;
      width: 254px;
      overflow: hidden;
      border-radius: 10px;
      margin-right: 24px;
      background: #fff;
      position: relative;
      vertical-align: top; // 此处新增
      .min{
        position: absolute;
        display: inline-block;
        top: 120px;
        right: 11px;
        font-size: 24px;
        background: rgba(0, 0, 0, .3);
        border-radius: 14px;
        color: #fff;
        padding: 0 12px;
        height: 32px;
        line-height: 32px;
        vertical-align: middle; // 此处新增
      }

      .cover_pic{
        display: block;
        width: 100%;
        height: 160px;
        position: relative;
        overflow: hidden;
        box-shadow: 1px solid #bfbfbf;
        .pass{
          position: absolute;
          /* 以下两行实现垂直水平居中 */
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%); /* 关键：基于自身尺寸偏移 */

          /* 以下为容器样式 */
          background: rgba(0, 0, 0, .3);
          border-radius: 50%;
          width: 50px;
          height: 50px;
          padding: 12px; /* 如果有需要可以保留 */

          /* 新增以下代码让 SVG 居中 */
          display: flex;
          align-items: center;
          justify-content: center;
          svg{
            width: 100%;
            height: 100%;
          }
        }
        img{
          width: 100%;
          height: 100%;
        }
      }
      .name{
        font-size: 26px;
      }
      .item-name{
        box-sizing: border-box;
        display: inline-block;
        overflow: hidden;
        padding: 17px 17px 20px;
        height: 85px;
        font-size: 25px;
        line-height: 36px;
        white-space: normal;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        vertical-align: top; // 此处新增
      }
      .mengceng{
        display: none;
      }
      &.active{
        .item-name{
          color: #f6451b;
        }
        .mengceng{
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          background:rgba(0, 0, 0, 0.25);
        }
      }
    }

  }
}
.videoList-box{
  background: #fff;
  overflow: hidden;
  width: 100%;
}
.videoList{
  padding-left: 36px;
  background: #f6f6f6;
  padding-bottom: 40px;
  border-radius: 30px 30px 0 0;
  .video_count{
    font-size: 32px;
    font-weight: bold;
    height: 110px;
    line-height: 130px;
  }
  .segmen_name{
    display: inline-block;
    height: 48px;
    font-size: 26px;
    font-weight: bold;
    line-height: 48px;
    background: #fff;
    padding: 0 25px 0 17px;
    border-radius: 10px;
    position: relative;
    &::before{
      content: '';
      display: inline-block;
      width: 6px;
      height: 24px;
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -12px;
      background: #f6451b;
      border-radius: 3px;
    }
  }
}
.xiajia{
  font-size: 26px;
  text-align: center;
  line-height: 50px;
}
.title{
  height: 115px;
  .hs-title{
    display: block;
    font-size: 36px;
    float: left;
    line-height: 115px;
    font-weight: bold;
  }
  .zhuanji{
    float: left;
    margin-left: 10px;
    font-size: 20px;
    background: #22b07d;
    height: 36px;
    color: #fff;
    padding: 0 8px;
    border-radius: 5px;
    margin-top: 39.5px;
    transform: scale(0.8);
    line-height: 36px;  // 修改为与高度相同
  }
}
.header-img{
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  margin-bottom: 22px;
  img{
    width: 64px;
    height: 64px;
    margin-right: 18px;
    border-radius: 50%;
    box-shadow: 1px solid #bfbfbf;
  }
  .header-title{
    flex: 1;
    font-size: 26px;
    color: #202020;
  }
  .buylink{
    float: right;
    //background-image: linear-gradient(to right, #fe7450 , #f6451b);
    padding: 19px 28px;
    border-radius: 40px;
    color: #f6451b;
    border-color: #f6451b;
    font-size: 24px;
    border: 2px solid #f6451b;
    margin-right: 30px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
  }
  .palyall{
    float: right;
    background-image: linear-gradient(to right, #fe7450 , #f6451b);
    padding: 21px 33px;
    border-radius: 40px;
    color: #fff;
    font-size: 24px;
    display: flex;
    //width: 141px;
    //height: 64px;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
    >div{
      >img{
        float: left;
        //width: 20px;
        width: auto;
        height: 24px;
        margin-right: 8px;
        vertical-align: middle;
        border-radius: 0;
      }
      >span{
        float: left;
        line-height: 24px;
        //margin-bottom: -3px;
        vertical-align: middle;
      }
    }
  }
  .palyall2{
    float: right;
    background-image: linear-gradient(to right, #fe7450 , #f6451b);
    padding: 21px 33px;
    border-radius: 40px;
    color: #fff;
    font-size: 24px;
    display: flex;
    margin-left: 18px;
    //width: 141px;
    //height: 64px;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
    >div{
      >img{
        float: left;
        //width: 20px;
        width: auto;
        height: 24px;
        margin-right: 8px;
        vertical-align: middle;
        border-radius: 0;
      }
      >span{
        float: left;
        line-height: 24px;
        //margin-bottom: -3px;
        vertical-align: middle;
      }
    }
  }
}
.text-content{
  box-sizing: border-box;
  width: 100%;
  padding: 0 38px;
  background: #fff;
}
.synopsis{
  font-size: 24px;
  color: #888;
  display: flex;
  padding-bottom: 28px;

  .synopsis-text{
    flex: 1;
    line-height: 37px;
    &.zhankai{
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  >span{
    width: 20px;
    position: relative;
    cursor: pointer;
    >img{
      width: 30px;
      height: 30px;
      position: absolute;
      bottom: 0;
    }
  }
}
.container {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 20vh; /* 使用视口高度，占据整个可视区域 */
}

.circle {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background-color: #ccc; /* 灰色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.image {
  width: 39px;
  height: 39px;
}

.text {
  line-height: 24px;
  font-size: 24px;
  margin-top: 22px;
  color: #cccccc;
}
.pdf-app.light {
  --pdf-app-background-color: #fffff;
  --pdf-sidebar-content-color: rgba(108,117,125,0.4);
  --pdf-toolbar-sidebar-color: rgba(108,117,125,0.7);
  --pdf-toolbar-color: #6c757d;
  --pdf-loading-bar-color: #3f4b5b;
  --pdf-loading-bar-secondary-color: #8dd0ff;
  --pdf-find-results-count-color: #3f4b5b;
  --pdf-find-results-count-font-color: hsla(0,0%,100%,0.87);
  --pdf-find-message-font-color: hsla(0,0%,100%,0.87);
  --pdf-not-found-color: brown;
  --pdf-split-toolbar-button-separator-color: #000;
  --pdf-toolbar-font-color: hsla(0,0%,100%,0.87);
  --pdf-button-hover-font-color: #8dd0ff;
  --pdf-button-toggled-color: #3f4b5b;
  --pdf-horizontal-toolbar-separator-color: #000;
  --pdf-input-color: #3f4b5b;
  --pdf-input-font-color: #d9d9d9;
  --pdf-find-input-placeholder-font-color: #8dd0ff;
  --pdf-thumbnail-selection-ring-color: rgba(108,117,125,0.7);
  --pdf-thumbnail-selection-ring-selected-color: #3f4b5b;
  --pdf-error-wrapper-color: #f55;
  --pdf-error-more-info-color: #d9d9d9;
  --pdf-error-more-info-font-color: #000;
  --pdf-overlay-container-color: rgba(108,117,125,0.7);
  --pdf-overlay-container-dialog-color: #6c757d;
  --pdf-overlay-container-dialog-font-color: #d9d9d9;
  --pdf-overlay-container-dialog-separator-color: #000;
  --pdf-dialog-button-font-color: #d9d9d9;
  --pdf-dialog-button-color: #3f4b5b;
}
.pdftool-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 38px;
  background-color: #f5f5f5;
  //height: 92px;
  height: calc(100vw * (110 / 750)); /* 高度按设计稿比例计算 */
  position: sticky;
  top: calc(100vw * (110 / 750)); /* 与 tip 的高度一致 */
  z-index: 999;
  //width: 100%;
}

.pagination {
  display: flex;
  align-items: center;
}

.current-page {
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border: 1px solid #ccc;
  margin-right: 5px;
}

.total-pages {
  font-size: 30px;
  color: #333;
}

/* 基础按钮样式 */
.up-button, .down-button, .grid-button {
  width: 60px;
  height: 60px;
  border: none !important;         /* 强制移除边框 */
  //border: 1px solid #ccc;
  cursor: pointer;
  background-color: transparent; /* 移除默认背景色 */
  background-size: contain;      /* 确保图片按比例缩放 */
  background-position: center;   /* 图片居中 */
  background-repeat: no-repeat;  /* 防止重复 */
}

/* 上箭头按钮（示例使用占位图，替换为实际路径） */
.up-button {
  background-image: url('../../assets/img/dingbu@3x.png');
  margin-right: 60px; /* 设置与down-button的间距 */
}

/* 下箭头按钮 */
.down-button {
  background-image: url('../../assets/img/dibu@3x.png');
}

/* 网格按钮 */
.grid-button {
  background-image: url('../../assets/img/caidan@3x.png');
}
.pdf-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.01); /* 几乎透明的覆盖层 */
  cursor: pointer; /* 显示为可点击状态 */
}

/* 禁止文本选择的CSS */
.no-text-select {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none;   /* Safari */
  -khtml-user-select: none;    /* Konqueror HTML */
  -moz-user-select: none;      /* Firefox */
  -ms-user-select: none;       /* Internet Explorer/Edge */
  user-select: none;           /* 非前缀版本，目前支持Chrome和Opera */
}

/* 针对PDF文本层的特殊处理 */
.pdf-app .textLayer {
  opacity: 1.0;
  pointer-events: none !important; /* 彻底禁止鼠标交互 */
}

/* 禁止文本层中的文本被选中 */
.pdf-app .textLayer > span {
  cursor: default !important;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  -khtml-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}

/* 自定义全宽PDF样式 */
.full-width-pdf {
  width: 100%;
}

/* 移除PDF页面的边框和阴影 */
.full-width-pdf .pdfViewer .page {
  margin: 0 auto !important;
  border: none !important;
  box-shadow: none !important;
  background-clip: border-box !important;
}

/* 移除page容器的边距 */
.full-width-pdf .pdfViewer {
  padding: 0 !important;
  margin: 0 !important;
}

/* 让PDF与页面融为一体的样式 */
.full-width-pdf #viewerContainer {
  background-color: #fff !important;
  overflow: visible !important;
}

/* 调整工具栏位置，让其融入页面 */
.full-width-pdf #toolbarContainer {
  background-color: #fff !important;
  box-shadow: none !important;
}

.pdf-app .pdfViewer .page {
  direction: ltr;
  width: 816px;
  height: 1056px;
  margin: 0 0 !important;
  //margin: 1px auto -8px auto;
  position: relative;
  overflow: visible;
  border: 99px solid transparent;
  background-clip: content-box;
  -o-border-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAA6UlEQVR4Xl2Pi2rEMAwE16fm1f7/r14v7w4rI0IzLAF7hLxNevBSEMEF5+OilNCsRd8ZMyn+a4NmsOT8WJw1lFbSYgGFzF2bLFoLjTClWjKKGRWpDYAGXUnZ4uhbBUzF3Oe/GG/ue2fn4GgsyXhNgysV2JnrhKEMg4fEZcALmiKbNhBBRFpSyDOj1G4QOVly6O1FV54ZZq8OVygrciDt6JazRgi1ljTPH0gbrPmHPXAbCiDd4GawIjip1TPh9tt2sz24qaCjr/jAb/GBFTbq9KZ7Ke/Cqt8nayUikZKsWZK7Fe6bg5dOUt8fZHWG2BHc+6EAAAAASUVORK5CYII=) 9 9 repeat;
  //border-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAA6UlEQVR4Xl2Pi2rEMAwE16fm1f7/r14v7w4rI0IzLAF7hLxNevBSEMEF5+OilNCsRd8ZMyn+a4NmsOT8WJw1lFbSYgGFzF2bLFoLjTClWjKKGRWpDYAGXUnZ4uhbBUzF3Oe/GG/ue2fn4GgsyXhNgysV2JnrhKEMg4fEZcALmiKbNhBBRFpSyDOj1G4QOVly6O1FV54ZZq8OVygrciDt6JazRgi1ljTPH0gbrPmHPXAbCiDd4GawIjip1TPh9tt2sz24qaCjr/jAb/GBFTbq9KZ7Ke/Cqt8nayUikZKsWZK7Fe6bg5dOUt8fZHWG2BHc+6EAAAAASUVORK5CYII=) 9 9 repeat;
  background-color: #fff;
}
.pdf-overlay-for-scroll {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: transparent; /* 完全透明的覆盖层 */
}

/* 当PDF工具栏未吸顶时禁用PDF滚动 */
.disable-pdf-scroll {
  overflow: hidden !important;
}

/* 当PDF工具栏吸顶时启用PDF滚动 */
.enable-pdf-scroll {
  overflow: auto !important;
}

/* 全屏遮罩层样式 */
.pdf-fullscreen-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.01); /* 几乎透明的遮罩 */
  cursor: pointer; /* 显示为可点击状态 */
}

/* 自定义缩略图页码样式 */
:global(.thumbnail-page-number) {
  position: relative;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: bold;
  margin-top: 5px;
  text-align: center;
  z-index: 2;
}

/* 修改PDF侧边栏样式，使其在右侧显示 */
:global(#mainContainer) {
  flex-direction: row-reverse !important;
}

:global(#sidebarContainer) {
  border-left: 1px solid #ddd !important;
  border-right: none !important;
}

:global(.thumbnail) {
  position: relative !important;
  margin: 10px auto !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  padding-bottom: 15px !important;
}

:global(.thumbnail .thumbnailImage) {
  margin-bottom: 5px !important;
}

:global(.toolbar), :global(.toolbarSidebar), :global(.tabsToolbar) {
  display: none !important;
}

/* 确保缩略图视图中没有工具栏等干扰元素 */
:global(#thumbnailView) {
  padding-top: 0 !important;
  position: absolute !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  overflow: auto !important;
}

:global(#sidebarContainer) {
  border-left: 1px solid #ddd !important;
  border-right: none !important;
  padding-top: 0 !important;
}

:global(#sidebarContent) {
  padding-top: 0 !important;
}

/* 隐藏侧边栏所有工具栏 */
:global(#sidebarContainer .toolbar), 
:global(#sidebarContainer .tabsToolbar) {
  display: none !important;
  height: 0 !important;
  min-height: 0 !important;
  max-height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
}

/* 当侧边栏关闭时确保完全隐藏 */
:global(#outerContainer:not(.sidebarOpen) #sidebarContainer) {
  display: none !important;
}


</style>